import React from 'react';
import { connect } from 'react-redux';
import {DeleteDialog} from 'modules/dialog';
import {Input, DropDownTreeSelectOneElement} from 'components/tt-forms/common';
import {validatable} from 'components/utils';
import { DuLieuHeThong } from 'api';

class RowItemAddReceptionPeriodical extends React.Component {
  constructor(props, context) {
    super(props);
    this.state = {
      data: this.props.data
    }
  }

  componentDidMount() {
    if(this.props.data.length == 0) {
      DuLieuHeThong.actions.getCoQuanTiepDan.request().then(res => {
        this.props.dispatch({
          type: 'CAPNHAT_DULIEUHETHONG',
          duLieuHeThong: [{
            key: 'coQuanTiepDanList',
            data: res.data && res.data._embedded && res.data._embedded.coQuanQuanLies ? res.data._embedded.coQuanQuanLies : []
          }]
        })
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data != this.props.data) {
      this.state.data = nextProps.data;
      this.setState({...this.state})
    }
  }

  onChange(name, e) {
    this.props.parent.handleChangeEditableTLBS((this.props.count-1), name, e.target.value);
  }
  render() {
    return (
      <tr>
        <td style={{width: 45, minWidth: 45, maxWidth: 45}}>{this.props.count}</td>
        <td style={{width: 300, minWidth: 300, maxWidth: 250, padding: 10}}>
          <DropDownTreeSelectOneElement className='col-100 mb0-18' bindValidator={this} channel="formTaoDon" placeholder require dataOptions={this.state.data} value={this.props.item.tencoquan} onChange={this.onChange.bind(this, 'tencoquan')} propertyChildren='coQuanQuanLyCha' propertyParent='coQuanQuanLyId' name={`cqCungTiepDan${this.props.count}`}/>
        </td>
        <td style={{ minWidth: 200, padding: 10}}>
          <Input className="col-100 mb0-18" value={this.props.item.nguoiDaiDien} onChange={this.onChange.bind(this, 'nguoiDaiDien')} name={`nguoiDaiDien${this.props.count}`}/>
        </td>
        <td style={{ minWidth: 200, padding: 10}}>
          <Input className="col-100 mb0-18" value={this.props.item.chucVu} onChange={this.onChange.bind(this, 'chucVu')} name={`chucVu${this.props.count}`}/>
        </td>
        <td style={{minWidth: 110, textAlign: 'left'}}>
          <div className="todo-wrap">
            <DeleteDialog
              title= {'Xác nhận'}
              content= {'Bạn chắc chắn muốn xoá cơ quan này?'}
              onSuccess={this.props.parent.handleRemove.bind(this.props.parent, (this.props.count-1), 'dsCoQuanToChucTiepDan')}
              index={this.props.count-1}
            />
          </div>
        </td>
      </tr>
    );
  }
}

RowItemAddReceptionPeriodical.defaultProps = {
  data: []
}

function bindStateToProps(state) {
  return {
    data: state.duLieuHeThong.coQuanTiepDanList
  };
}

export default connect(bindStateToProps)(validatable(RowItemAddReceptionPeriodical));



// WEBPACK FOOTER //
// ./src/components/modules/reception-periodical/datatable/add/RowItemAddReceptionPeriodical.jsx